<template>
	<img>
</template>

<script>
import Vue from 'vue';
export default {
	name: 'VueImg',
	props: ['data'],
	watch: {
		data(image, was) {
			let vm = this;
			Vue.nextTick()
				.then(() => {
					vm.$el.src = image;
				});
		},

	},
	mounted(){
		this.$el.src = this.data;
	}
};
</script>



// WEBPACK FOOTER //
// ./src/components/VueImg.vue